<style>
.atd-theme > div {
    width: 53px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none;*/
    -webkit-appearance: none;
    margin: 0;
}
div.vue-swatches__container:not(.vue-swatches--inline) {
    z-index: 999;
}
</style>

<style scoped>
a.el-button.el-button--info.pull-right:hover,
.el-button--info:focus,
.el-button--info:active {
    border-color: #fff;
    background-color: #fff;
    color: #333;
}
.content-wrapper .content {
    padding-top: 95px;
}
.domain-div{
    display: flex;
    align-items: center;
    margin-top: 8px;
}
.domain-checkbox{
    margin-top: 4px;
    margin-left: 5px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.el-select {
    display: block;
}
.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.el-input-group__prepend {
    cursor: pointer;
}
button[disabled='disabled'],
button:disabled {
    background-color: rgba(200, 200, 200, 2.2);
    cursor: not-allowed;
    border-color: rgba(200, 200, 200, 2.2);
}
.col-md-3 {
    margin-top: 0;
}
.m-t-15 {
    margin-top: 15px;
}
.col-md-12 {
    padding-left: 0px;
    padding-right: 0px;
}
.col-md-9 {
    padding-left: 0px;
    padding-right: 0px;
}
.row {
    margin-left: 0px;
    margin-right: 0px;
}
</style>
<template>
    <!-- <transition name="el-zoom-in-top"> -->
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Create Bulk line item</h3>
                </div>
                <div class="box-body" v-loading="isLoading">
                    <form method="post" class="form">
                        <h5>Select Publisher</h5>
                        <p>Choose publisher from the dropdown or create one by clicking +add publisher</p>
                        <div class="row">
                            <div class="col-md-9">
                                <el-select v-model="pubId" placeholder="Select" filterable @change="setPubUid()">
                                    <el-option
                                        v-for="pub in publishers"
                                        :data-id="pub.uuid"
                                        :key="pub.name"
                                        :label="pub.name"
                                        :value="pub.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="btn">
                                <router-link to="/admin/bidders/create-publisher/" class="el-button--info m-t-15">
                                    <i class="el-icon-plus el-icon-left"></i>
                                    Create Publisher
                                </router-link>
                            </div>
                        </div>

                        <div class="domain-div"><h5>Select Domain</h5><el-checkbox :checked="handleChecked()" v-show="pubId" class="domain-checkbox" :value="checkedAllDomains" @input="handleCheckAllDomains" label="Select All" size="large" /></div>
                        <div class="row">
                            <div class="p-t-1 of-auto">
                                <el-select v-model="domId" placeholder="Select" filterable multiple clearable>
                                    <el-option
                                        v-for="dom in domains"
                                        :data-id="dom.uuid"
                                        :key="dom.id"
                                        :label="dom.url"
                                        :value="dom.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="p-t-1 of-auto">
                            <h5>Name</h5>
                            <el-input
                                v-validate="'required'"
                                data-vv-delay="1000"
                                class="col-md-12"
                                name="name"
                                type="text"
                                placeholder="Enter LineItem Name"
                                v-model="createLineItemForm.name"
                            ></el-input>
                            <span v-show="errors.has('name')" class="help is-danger" style="color: red">{{
                                errors.first('name')
                            }}</span>
                        </div>

                        <div class="p-t-1 of-auto">
                            <h5>Enable</h5>
                            <el-switch class="col-md-12" v-model="createLineItemForm.active"></el-switch>
                        </div>
                        <div>
                            <div class="p-t-1 of-auto">
                                <h5>Vertical:</h5>
                                <el-select
                                    class="col-md-12"
                                    v-validate="'required'"
                                    v-model="createLineItemForm.vertical"
                                    placeholder="Select"
                                >
                                    <el-option
                                        v-for="item in placementVertical"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="p-t-1 of-auto">
                            <h5>Type:</h5>
                            <el-select
                                class="col-md-12"
                                v-validate="'required'"
                                v-model="selectedTypes"
                                placeholder="Select"
                                @change="setDevicesForAMP"
                            >
                                <el-option v-for="item in placementType" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="p-t-1 of-auto">
                            <h5>Geo</h5>
                            <el-select
                                class="param-set-input select-input col-md-12"
                                v-model="selectedCountries"
                                multiple
                                placeholder="Select Country"
                                v-validate="'required'"
                                name="Country"
                                filterable
                            >
                            <!-- @change="validateUnique('country')" -->
                                <el-option
                                    v-for="country in countries"
                                    :key="country.id"
                                    :label="country.name"
                                    :value="country.id"
                                ></el-option>
                            </el-select>
                            <span v-show="errors.has('Country')" class="help is-danger" style="color: red">{{
                                errors.first('Country')
                            }}</span>
                        </div>

                        <div class="p-t-1 of-auto">
                            <h5>Device</h5>
                            <el-select
                                class="param-set-input select-input col-md-12"
                                multiple
                                v-model="selectedDevices"
                                placeholder="Select Device"
                                v-validate="'required'"
                                name="Devices"
                            >
                                <!-- @change="validateUnique('device')" -->
                                <el-option
                                    v-for="device in devices"
                                    :key="device.id"
                                    :label="device.name"
                                    :value="device.id"
                                >
                                </el-option>
                            </el-select>
                            <span v-show="errors.has('Devices')" class="help is-danger" style="color: red">{{
                                errors.first('Devices')
                            }}</span>
                        </div>
                        <div class="p-t-1 of-auto">
                            <h5>Browser</h5>
                            <el-select
                                class="param-set-input select-input col-md-12"
                                multiple
                                v-model="selectedBrowsers"
                                placeholder="Select Browsers"
                                v-validate="'required'"
                                name="Browsers"
                            >
                             <!-- @change="validateUnique('browser')" -->
                                <el-option
                                    v-for="browser in browsers"
                                    :key="browser.id"
                                    :label="browser.name"
                                    :value="browser.id"
                                ></el-option>
                            </el-select>
                            <span v-show="errors.has('Browsers')" class="help is-danger" style="color: red">{{
                                errors.first('Browsers')
                            }}</span>
                        </div>

                        <div class="p-t-1 of-auto">
                            <h5>Dimension</h5>
                            <div>
                                <el-select
                                    v-model="selectedDimensions"
                                    class="col-md-12"
                                    placeholder="Select Dimensions"
                                    v-validate="'required'"
                                    name="Dimensions"
                                    multiple
                                    @change="
                                        getAllPositionsForDimension(selectedDimensions);
                                    "
                                    @remove-tag="updateCreativeList(createLineItemForm, $event)"
                                    filterable
                                >
                                    <!-- validateUnique('dimension'); -->
                                    <el-option
                                        v-for="(dimension, index) in dimensions"
                                        :key="index"
                                        :label="`${dimension.width}X${dimension.height}`"
                                        :value="dimension.id"
                                        :disabled="disabledSize.indexOf(dimension.id) > -1"
                                    ></el-option>
                                </el-select>
                                <span v-show="errors.has('Dimensions')" class="help is-danger" style="color: red">{{
                                    errors.first('Dimensions')
                                }}</span>
                            </div>
                        </div>

                        <div class="p-t-1 of-auto">
                            <div v-if="selectedDimensions.length > 0">
                                <div class="m-t-15 m-b-15" v-for="(dim, index) in selectedDimensions" :key="index">
                                    <div class="dis-flex">
                                        <span style="width: 75px; margin-top: 10px;"
                                            >{{
                                                dimensions.length &&
                                                dimensions.filter((k) => k.id == dim)[0].width +
                                                    'X' +
                                                    dimensions.filter((k) => k.id == dim)[0].height
                                            }}
                                            -
                                        </span>
                                        <div style="width: 68%">
                                            <el-select
                                                v-model="createLineItemForm.creativeIds[index]"
                                                class="col-md-12"
                                                placeholder="Select Creative"
                                                v-validate="'required'"
                                                name="Creatives"
                                                @change="addCreativeToLineItem(createLineItemForm, index)"
                                                filterable
                                            >
                                                <el-option
                                                    v-for="(creative, idx) in getCreativeList(dim)"
                                                    :key="idx"
                                                    :label="creative.name"
                                                    :value="creative.id"
                                                ></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                        <div class="row" v-if="
                                            createLineItemForm.creative.length > index &&
                                            createLineItemForm.creative[index]">
                                        <!-- {{createLineItemForm.creative[index]}} -->
                                        <div style="width:68%; margin-left: 75px; margin-top: 10px;" v-if="createLineItemForm.creative[index].isS2S==true">
                                            Tag ID :<el-input v-model="createLineItemForm.creative[index].tagId"></el-input>
                                        </div>
                                        </div>
                                    <div
                                        class="row"
                                        style="border-bottom: 1px solid #ececec; padding-bottom: 19px"
                                        v-if="
                                            createLineItemForm.creative.length > index &&
                                            createLineItemForm.creative[index] &&
                                            createLineItemForm.creative[index].modify == true
                                        "
                                    >
                                        <div class="col-md-3 p-t-15">
                                            <div>Modified creative name:</div>
                                            <el-input
                                                v-validate="'required|alpha_dash'"
                                                data-vv-delay="1000"
                                                class=""
                                                name="name"
                                                type="text"
                                                placeholder="Enter Creative Name"
                                                v-model="createLineItemForm.creative[index].name"
                                            ></el-input>
                                        </div>
                                        <div class="col-md-2 p-t-15">
                                            <div>Font-Size:</div>
                                            <el-select
                                                filterable
                                                v-model="createLineItemForm.creative[index].font_size"
                                            >
                                                <el-option
                                                    v-for="(fontSize, index) in allFontSizes"
                                                    :key="index"
                                                    :label="fontSize"
                                                    :value="fontSize"
                                                >
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div class="col-md-1">
                                            <div>Font Color:</div>
                                            <swatch
                                                v-model="createLineItemForm.creative[index].font_color"
                                                colors="text-advanced"
                                                popover-to="top"
                                                style="width: 50px; height: 50px"
                                                show-fallback
                                            ></swatch>
                                        </div>
                                        <div class="col-md-1">
                                            <div>CTA Color:</div>
                                            <swatch
                                                v-model="createLineItemForm.creative[index].cta_color"
                                                colors="text-advanced"
                                                popover-to="top"
                                                style="width: 50px; height: 50px"
                                                show-fallback
                                            ></swatch>
                                        </div>
                                        <div class="col-md-2">
                                            <div>Background Color:</div>
                                            <swatch
                                                v-model="createLineItemForm.creative[index].background_color"
                                                colors="text-advanced"
                                                popover-to="top"
                                                style="width: 50px; height: 50px"
                                                show-fallback
                                            ></swatch>
                                        </div>
                                        <div class="creative-save-btn">
                                            <el-button
                                                type="success"
                                                style="margin-top: 10px"
                                                @click="saveCreative(createLineItemForm.creative[index], index)"
                                                >Save</el-button
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-t-1 of-auto">
                            <h5>Placement</h5>
                            <div
                                v-for="(data, index) in createLineItemForm.placements"
                                :key="`${index}positioninput`"
                                class="col-md-12 dis-flex"
                            >
                                <el-select
                                    clearable
                                    @remove-tag="convertObjToRegex('placements')"
                                    @change="convertObjToRegex('placements')"
                                    v-model="createLineItemForm.placements[index].operator"
                                    class="col-md-3 "
                                    style="padding: 0 5px 5px 0"
                                    placeholder="Select an Operator"
                                    name="Operator"
                                    reserve-keyword
                                    allow-create
                                >
                                    <el-option
                                        v-for="(operator, index) in [
                                            ['Starts With', 'starts_with'],
                                            ['Ends With', 'ends_with'],
                                            ['Contains', 'contains'],
                                            ['Equals', 'equals'],
                                            ['Does Not Contain', 'does_not_contain'],
                                        ]"
                                        :key="index"
                                        :label="operator[0]"
                                        :value="operator[1]"
                                    ></el-option>
                                </el-select>
                                <el-input
                                    class="col-md-11"
                                    style="margin: 0 5px 0 0; padding: 0px 0px 5px 5px"
                                    data-vv-delay="1000"
                                    name="placementName"
                                    type="text"
                                    placeholder="Enter Placement Name"
                                    v-model="createLineItemForm.placements[index].data"
                                    @remove-tag="convertObjToRegex('placements')"
                                    @change="convertObjToRegex('placements')"
                                ></el-input>
                                <el-button
                                    v-if="index === createLineItemForm.placements.length - 1"
                                    style="
                                        height: 100%;
                                        text-align: center;
                                        padding-left: 0;
                                        padding-right: 0;
                                        margin-top: 0px;
                                    "
                                    type="secondary"
                                    class="col-md-1"
                                    @click="
                                        addNewItem(index, 'placements');
                                        convertObjToRegex('placements');
                                    "
                                    >OR</el-button
                                >
                                <el-button
                                    v-else
                                    style="height: 100%; text-align: center; padding-left: 0; padding-right: 0"
                                    type="danger"
                                    class="col-md-1"
                                    @click="
                                        createLineItemForm.placements.splice(index, 1);
                                        convertObjToRegex('placements');
                                    "
                                >
                                    <i class="fa fa-trash"></i>
                                </el-button>
                            </div>
                        </div>
                        <div class="p-t-1 of-auto">
                            <h5>Position</h5>
                            <div
                                v-for="(data, index) in createLineItemForm.positions"
                                :key="`${index}positioninput`"
                                class="col-md-12 dis-flex"
                            >
                                <el-select
                                    clearable
                                    @remove-tag="convertObjToRegex('positions')"
                                    @change="convertObjToRegex('positions')"
                                    v-model="createLineItemForm.positions[index].operator"
                                    class="col-md-3"
                                    style="padding: 0 5px 5px 0"
                                    placeholder="Select an Operator"
                                    name="Operator"
                                    reserve-keyword
                                    allow-create
                                >
                                    <el-option
                                        v-for="(operator, index) in [
                                            ['Starts With', 'starts_with'],
                                            ['Ends With', 'ends_with'],
                                            ['Contains', 'contains'],
                                            ['Equals', 'equals'],
                                            ['Does Not Contain', 'does_not_contain'],
                                        ]"
                                        :key="index"
                                        :label="operator[0]"
                                        :value="operator[1]"
                                    ></el-option>
                                </el-select>
                                <el-select
                                    clearable
                                    class="col-md-11"
                                    style="margin: 0 5px 0 0; padding: 0px 0px 5px 5px"
                                    v-model="createLineItemForm.positions[index].data"
                                    allow-create
                                    remote
                                    :remote-method="positionFilter"
                                    placeholder="Select or Add Position"
                                    name="Positions"
                                    @remove-tag="convertObjToRegex('positions')"
                                    @change="convertObjToRegex('positions')"
                                    :loading="positionsListLoading"
                                    reserve-keyword
                                    filterable
                                >
                                    <el-option
                                        v-for="(pos, index) in posOptions"
                                        :key="index"
                                        :label="pos"
                                        :value="pos"
                                    ></el-option>
                                </el-select>
                                <el-button
                                    v-if="index === createLineItemForm.positions.length - 1"
                                    style="
                                        height: 100%;
                                        text-align: center;
                                        padding-left: 0;
                                        padding-right: 0;
                                        margin-top: 0;
                                    "
                                    type="secondary"
                                    class="col-md-1"
                                    @click="
                                        addNewItem(index, 'positions');
                                        convertObjToRegex('positions');
                                    "
                                    >OR</el-button
                                >
                                <el-button
                                    v-else
                                    style="height: 100%; text-align: center; padding-left: 0; padding-right: 0"
                                    type="danger"
                                    class="col-md-1"
                                    @click="
                                        createLineItemForm.positions.splice(index, 1);
                                        convertObjToRegex('positions');
                                    "
                                >
                                    <i class="fa fa-trash"></i>
                                </el-button>
                            </div>
                        </div>

                        <div>
                            <div class="p-t-1 of-auto">
                                <h5>Bid CPM(USD) Min:</h5>
                                <el-input
                                    type="number"
                                    value="0"
                                    data-vv-delay="1000"
                                    class="col-md-12"
                                    name="Bid CPM(USD) Min:"
                                    v-model="createLineItemForm.bid_cpm_min"
                                    :rows="10"
                                    placeholder="Enter Min ECPM"
                                ></el-input>
                                <span
                                    v-show="errors.has('Bid CPM(USD) Min:')"
                                    class="help is-danger"
                                    style="color: red"
                                    >{{ errors.first('Bid CPM(USD) Min:') }}</span
                                >
                            </div>
                            <div class="p-t-1 of-auto">
                                <h5>Bid CPM(USD) Max:</h5>
                                <el-input
                                    type="text"
                                    data-vv-delay="1000"
                                    class="col-md-12"
                                    name="Bid CPM(USD) Max:"
                                    v-model="createLineItemForm.bid_cpm_max"
                                    :rows="10"
                                    placeholder="Enter Max ECPM"
                                ></el-input>
                                <span
                                    v-show="errors.has('Bid CPM(USD) Max:')"
                                    class="help is-danger"
                                    style="color: red"
                                    >{{ errors.first('Bid CPM(USD) Max:') }}</span
                                >
                            </div>

                            <div class="p-t-1 of-auto">
                                <h5>Budget (USD):</h5>
                                <el-input
                                    type="text"
                                    data-vv-delay="1000"
                                    class="col-md-12"
                                    name="Budget (USD):"
                                    v-model="createLineItemForm.budget"
                                    :rows="10"
                                    placeholder="Enter Line item budget (USD)"
                                ></el-input>
                                <span v-show="errors.has('Budget (USD):')" class="help is-danger" style="color: red">{{
                                    errors.first('Budget (USD):')
                                }}</span>
                            </div>
                        </div>
                        <span slot="footer" class="dialog-footer">
                            <el-button
                                type="success"
                                @click="createLineItem($event)"
                                style="margin-top: 10px"
                                v-if="!isEditLineitem"
                                >Create Bulk Line item</el-button
                            >
                        </span>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script type="text/javascript" src="https://www.gstatic.com/charts/loader.js">
</script>

<script>
import axios from 'axios';
import Swatches from 'vue-swatches';
import VerEx from 'verbal-expressions';
import LineItemDetails from '../admin/AdspotDetails';
import theme from './Theme.vue';
export default {
    components: { theme },
    Swatch: Swatches,
    LineItemDetails,
    data: () => {
        return {
            domId: [],
            domains: [],
            checkedAllDomains: false,
            name: undefined,
            publishers: [],
            pubId: undefined,
            domUid: undefined,
            isLoading: true,
            positionsRegexExpression: '',
            positionList: [],
            placementType: ['AMP', 'prebid'],
            placementVertical: [],
            domain_id: '',
            dimensions: [],
            countries: [],
            browsers: [],
            selectedBrowsers: [1, 2, 3, 4],
            selectedCountries: [],
            selectedTypes : [],
            devices: [],
            selectedDevices: [1, 2, 3, 4, 5],
            isUniTag: false,
            lineitemidEdit: '',
            LineItems: [],
            selectedDimensions: [],
            selectedCreatives: [],
            creativeAssociation: {
                modify: false,
                name: '',
                background_color: '',
                cta_color: '',
                isS2S: false,
                tagId: '',
            },
            
            createLineItemForm: {
                active: false,
                name: '',
                bid_cpm_min: 0,
                bid_cpm_max: 0,
                budget: 0,
                creative: [],
                creativeIds: [],
                tagIds: [],
                isDoubleCreative: false,
                vertical: '',
                placements: [{ data: '', operator: '' }],
                domain: '',
                type: '',
                tagIds: [],
                positions: [{ data: '', operator: '' }],
            },
            creativeList: [],
            posOptions: [],
            disabledSize: [],
            dimensionTemp: [],
            allDomains: [],
        };
    },
    created: function () {
        axios
            .all([
                axios.get(BASE_URL + 'bidder/v1/publishers/?limit=1000'),
                axios.get(BASE_URL + 'bidder/v1/domains/?limit=1000'),
                axios.get(BASE_URL + 'v1/currencies/'),
            ])
            .then(
                axios.spread((response, currency) => {
                    this.publishers = response.data.results;
                    if (this.$route.query.publisher) {
                        for (let i = 0; i < this.publishers.length; i++) {
                            if (this.publishers[i].id == parseInt(this.$route.query.publisher)) {
                                this.pubId = parseInt(this.$route.query.publisher);
                            }
                        }
                    }
                    this.isLoading = false;
                })
            ),
            (this.domain_id = this.$route.params);
        this.loadCreatives();
        this.loadCountry();
        this.loadDevice();
        this.loadBrowser();
        this.getDomain();
    },
    mounted: function () {
        axios.get(BASE_URL + `bidder/v1/vertical-list/`).then((vertical) => {
            this.placementVertical = vertical.data;
        });
    },
    methods: {
        setPubUid() {
            this.domId = [];
            this.domains = this.allDomains.filter((d) => d.publisher == this.pubId);
            this.checkedAllDomains = false;
            this.handleCheckAllDomains();
        },
        handleCheckAllDomains(){
            this.checkedAllDomains = !this.checkedAllDomains;
            if(this.checkedAllDomains){
                this.domId = this.domains.map((d) => d.id);
            }else{
                this.domId = [];
            }
        },
        handleChecked(){
            this.checkedAllDomains = this.domains.length === this.domId.length;
        },
        convertRegexToString(expr) {
            return expr.toString().replace('/', '').replace('/gm', '');
        },
        convertObjToRegex(type) {
            var obj = [];
            this.createLineItemForm[type].forEach((typeValue) => {
                if (typeValue.data.length && typeValue.operator.length) {
                    obj.push(typeValue);
                }
            });
            var final_regex = '';
            var expression = '';
            for (var i in obj) {
                if (obj[i].operator == 'starts_with') {
                    expression = VerEx().add('^' + obj[i]['data']);
                }
                if (obj[i].operator == 'ends_with') {
                    // expression=VerEx().endOfLine().find(obj[i]['data'])
                    expression = VerEx().add(obj[i]['data'] + '$');
                }
                if (obj[i].operator == 'equals') {
                    expression = VerEx().add('^' + obj[i]['data'] + '$');
                }
                if (obj[i].operator == 'contains') {
                    expression = VerEx().find(obj[i]['data']);
                }
                if (obj[i].operator == 'does_not_contain') {
                    expression = VerEx().add('^' + '(?' + '!.*' + obj[i]['data'] + ')' + '.*');
                }
                if (i == 0) {
                    final_regex = expression;
                } else {
                    final_regex = final_regex.or(expression);
                }
            }
            var fin = final_regex == '' ? '' : final_regex.toRegExp();
            this[type + 'RegexExpression'] = this.convertRegexToString(fin); // positionsRegexExpression || placementsRegexExpression
        },
        
        positionFilter(query) {
            if (query !== '') {
                this.positionsListLoading = true;
                this.posOptions = this.positionList.filter((item) => {
                    return item && item.indexOf(query) > -1;
                });
                this.positionsListLoading = false;
            } else {
                this.posOptions = [];
            }
        },
        getAllPositionsForDimension(dimension, existingPositionEntries = []) {
            if (dimension.length === 0) return;
            var dim = [];
            for (var i in dimension) {
                dim.push(
                    this.dimensions.filter((k) => {
                        return k.id == dimension[i];
                    })[0]
                );
            }
            var dimensions = dim.map((k) => {
                return k.width + 'x' + k.height;
            });
            axios
                .get(BASE_URL + `bidder/v1/domains/divids/?publisher_id=${this.pubId}&dimensions=${dimensions}`)
                .then((pos) => {
                    if (pos.hasOwnProperty('data')) {
                        this.positionList = pos.data;
                        if (existingPositionEntries.length > 0) {
                            for (var k in existingPositionEntries) {
                                if (
                                    this.positionList.map((x) => x.data).indexOf(existingPositionEntries[k].data) == -1
                                ) {
                                    this.positionList.push(existingPositionEntries[k].data);
                                }
                            }
                        }
                    }
                })
                .catch((err) => {
                    console.error('failed to fetch positions: ', err);
                });
        },
        getDomain() {
            const api1 = BASE_URL + `bidder/v1/domain-list/`;
            axios.get(api1).then(async (response) => {
                this.allDomains = response.data.data;
            });
        },
        loadCreatives() {
            var apiCreatives = BASE_URL + 'bidder/v1/creatives/?limit=1000';
            axios.get(apiCreatives).then((creative) => {
                this.creativeList = creative.data.results;
                this.availableDimensions = [...new Set([].concat(...this.creativeList.map((k) => k.dimensions)))];
                this.loadAddimensions();
            });
        },
        updateCreativeList(liObj, event, sl) {
            if (liObj.creative.length > 0) {
                var toremove = liObj.creative.findIndex((k) =>
                    k && k.hasOwnProperty('dimension') ? k.dimension.indexOf(event.currentValue) > -1 : false
                );
                this.$delete(liObj.creative, toremove);
                this.$delete(liObj.creativeIds, toremove);
            }
        },
        getCreativeList(dimId) {
            var crList = this.creativeList.filter((k) => k.dimensions.indexOf(dimId) > -1);
            console.log('crList: ' + crList.isS2S);
            console.log('Creative ID: ' + crList[0].id);
            if (crList.length > 0) {
                return crList;
            }
            return [];
        },
        addCreativeToLineItem(lineItemObj, id) {
            var creativeObj = Object.assign({}, this.creativeAssociation);
            var creativeFormId = this.createLineItemForm.creativeIds;
            var creativeBase = this.creativeList.filter((k) => k.id == lineItemObj.creativeIds[id])[0];
            // creativeObj.name = creativeBase.name
            console.log('creativeBase.isS2S', creativeBase.isS2S);
            if (creativeBase.isS2S) {
                creativeObj.isS2S = creativeBase.isS2S;
            }
            if (creativeBase) {
                creativeObj.dimension = creativeBase.dimensions;
                this.$set(lineItemObj.creative, id, creativeObj);
            }
        },
     
        loadDevice() {
            var apiDevice = BASE_URL + 'bidder/v1/device-list/';
            axios.get(apiDevice).then((response) => {
                this.devices = [];
                this.devices.push(...response.data);
            });
        },
        loadBrowser() {
            var apiBrowser = BASE_URL + 'bidder/v1/browser-list/';
            axios.get(apiBrowser).then((response) => {
                this.browsers = [];
                this.browsers.push(...response.data);
            });
        },
        loadCountry() {
            var apiCountry = BASE_URL + 'v1/countries/';
            axios.get(apiCountry).then((response) => {
                this.countries = [];
                this.countries.push(...response.data);
            });
        },
        addNewItem(index, type) {
            let temp = this.createLineItemForm[type][index];
            if (temp.data.length && temp.operator.length) {
                this.createLineItemForm[type].push({ data: '', operator: '' });
            } else {
                this.$notify({
                    title: 'Error',
                    message: 'Input must have a value',
                    type: 'error',
                });
            }
        },
        setDevicesForAMP() {
            // for amp, by default only mobile devices selected
            if (this.createLineItemForm.type == 'AMP') {
                this.selectedDevices = [1, 2];
            } else {
                this.selectedDevices = [1, 2, 3, 4, 5];
            }
        },
        createLineItem(event) {
            event.stopPropagation();
            this.createLineItemForm.tagIds = this.createLineItemForm.creative
                .map((k, index) => {
                    if (k.tagId.length > 0) {
                        return {
                            tag_id: k.tagId,
                            creative: this.createLineItemForm.creativeIds[index],
                        };
                    }
                })
                .filter((k) => {
                    return k != null;
                });
            if (this.createLineItemForm.type.includes('tag')) {
                if (this.createLineItemForm.bid_cpm_min.length > 0) {
                    this.createLineItemForm.bid_cpm_max = this.createLineItemForm.bid_cpm_min;
                }
                if (this.isUniTag == true) {
                    this.createLineItemForm.type = 'unitag';
                } else {
                    this.createLineItemForm.type = 'tag';
                }
            }
            if (this.createLineItemForm.vertical.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please enter line item vertical',
                    type: 'error',
                });
                return;
            }
            if (this.selectedDevices.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select devices',
                    type: 'error',
                });
                return;
            }
            if (this.selectedCountries.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select a country',
                    type: 'error',
                });
                return;
            }
            if (this.selectedDimensions.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select Dimensions',
                    type: 'error',
                });
                return;
            }
            if (this.selectedBrowsers.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select browsers',
                    type: 'error',
                });
                return;
            }
            if(this.selectedTypes.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select type',
                    type: 'error',
                });
                return;
            }
            if (this.createLineItemForm.creativeIds.length != this.selectedDimensions.length) {
                this.$notify({
                    title: 'error',
                    message: 'Make sure all selected dimensions have creatives associated',
                    type: 'error',
                });
                return;
            }
            if (this.createLineItemForm.name.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please enter line item name',
                    type: 'error',
                });
                return;
            }
            if (this.createLineItemForm.isDoubleCreative == true && this.selectedDimensions.length > 1) {
                this.$notify({
                    title: 'error',
                    message: 'Only one dimension can be selected when double creative is enabled',
                    type: 'error',
                });
                return;
            }
            this.convertObjToRegex('positions');
            this.convertObjToRegex('placements');
            let LineitemObject = {
                name: this.createLineItemForm.name,
                active: this.createLineItemForm.active,
                country: this.selectedCountries,
                device: this.selectedDevices,
                type: this.selectedTypes,
                bid_cpm_min: this.createLineItemForm.bid_cpm_min,
                bid_cpm_max: this.createLineItemForm.bid_cpm_max,
                budget: this.createLineItemForm.budget,
                browsers: this.selectedBrowsers,
                tag_ids: this.createLineItemForm.tagIds,
                dimensions: this.selectedDimensions,
                creative: this.createLineItemForm.creativeIds,
                vertical: this.createLineItemForm.vertical,
              
                placement_text:
                    typeof this.createLineItemForm.placements == 'object'
                        ? [this.placementsRegexExpression]
                        : [this.createLineItemForm.placements],
                positions:
                    typeof this.createLineItemForm.positions == 'object'
                        ? this.positionsRegexExpression
                        : this.createLineItemForm.positions,
            };
            if (LineitemObject.placement_text[0] == '') {
                LineitemObject.placement_text = [];
            }
            if (LineitemObject.type == 'unitag') {
                delete LineitemObject.placement_text;
            }
            axios
                .post(BASE_URL + 'bidder/v1/lineitems/bulk_create/', { domain_list: this.domId, data: LineitemObject })
                .then((response) => {
                    this.$notify({
                        title: 'Request Sent',
                        message: 'Please check notifications after some time.',
                        type: 'warning',
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadAddimensions() {
            this.dimensionsAsPerIsDoubleCreative = [];
            var apidimension = BASE_URL + 'v1/ad-dimensions/';
            var dim = [
                '300x250',
                '320x50',
                '728x90',
                '970x90',
                '250x250',
                '300x50',
                '320x100',
                '336x280',
                '320x480',
                '970x250',
                '300x600',
                '320x250',
            ];
            axios.get(apidimension).then((response) => {
                let dimensions = response.data;
                this.dimensions = dimensions.filter((m) => this.availableDimensions.indexOf(m.id) > -1);
                this.dimensionTemp = dimensions.filter((m) => this.availableDimensions.indexOf(m.id) > -1);
                for (var i = 0; i < this.dimensions.length; i++) {
                    if (
                        (this.dimensions[i].width == 300 && this.dimensions[i].height == 600) ||
                        (this.dimensions[i].width == 970 && this.dimensions[i].height == 250) ||
                        (this.dimensions[i].width == 336 && this.dimensions[i].height == 280) ||
                        (this.dimensions[i].width == 300 && this.dimensions[i].height == 250)
                    ) {
                        this.dimensionsAsPerIsDoubleCreative.push(this.dimensions[i]);
                    }
                }
            });
        },
    },
};
</script>


// WEBPACK FOOTER //
// BulkLineItem.vue?39739320